import React from "react";
import { Button } from "@blueprintjs/core";
import Raw from "./Raw";
import api from "../../common/lib/api";
import { MobilePanicActions } from "./MobilePanicActions";
import { KeypadActions } from "./KeypadActions";

export default function LocationFunction({ token, device, node, liveStatus }) {
  return (
    <div style={{ border: "1px solid red" }}>
      <h3>{node.name}</h3>
      <Raw json={{ node, liveStatus }} />
      <p>
        <strong>Type:</strong> {node.type}
      </p>
      <p>
        <strong>Icon:</strong> {node.icon}
      </p>
      <p>
        <strong>State:</strong> {node.state}
      </p>
      {liveStatus && (
        <p>
          <strong>Live State:</strong> {liveStatus.state}
        </p>
      )}
      {node.type === "mobilePanic" && (
        <MobilePanicActions token={token} node={node} device={device} />
      )}
      {node.type === "keypad" && (
        <KeypadActions token={token} node={node} device={device} />
      )}
      {node.availableActions.length > 0 && (
        <StandardActions token={token} node={node} device={device} />
      )}
    </div>
  );
}

function StandardActions({ node, device }) {
  return (
    <p>
      <strong>Actions:</strong>{" "}
      {node.availableActions.map((action) => (
        <Button
          key={action}
          intent="primary"
          disabled={!node.allowedActions.includes(action)}
          onClick={async () => {
            const result = await api.post(
              `/devices/${device.deviceUuid}/device-nodes/${node.deviceNodeUuid}`,
              {
                action,
              }
            );
            console.log(result);
          }}
        >
          {action}
        </Button>
      ))}
    </p>
  );
}
